import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
//import { listSetting } from "../ListSalarySetiting.config";
import { formatToCurrencyType } from "helper/common";
import React from "react";

const { INPUT, DATE,DATE_DISABLE_NO_DAY, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER, DATE_PRE } =
  FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã cấu hình",
    name: "maCauHinh",
    disable: true,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
  },

  {
    type: COMBO_BOX,
    label: "Tên cấu hình ",
    name: "tenCauHinh",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
    disable: true,
   // rules: [{ required: true, message: "Chưa nhập Tên cấu hình" }],
   // options: listSetting,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "TG áp dụng từ ",
    name: "thoiGianApDungTu",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "TG áp dụng đến",
    name: "thoiGianApDungDen",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: NUMBER,
    label: "Giá trị",
    name: "giaTri",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
    disable: false,
  },
  {
    type: INPUT,
    label: "Mô tả",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
    name: "moTa",
    disable: false,
  },
];
export { dataFields };
